<script>


export default {
  data() {
    return {};
  },
  props: {
    loading: Boolean,
  },
  mounted() {
    // console.log('mounted loader_components_mobagile')

  },
};
</script>

<template>
  <div :class="{ 'is-loading': true }">
    <div class="preloader-component">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>
